/**
 * 📦 V2 Checkouts API client
 * Rotas /api/v2/checkouts
 *
 * V2.1 R19.5: 1 plano → N checkouts (mesma venda em URLs diferentes
 * com configurações distintas: cor, slug, métodos habilitados, etc.).
 */

import v2Api from './index';

export const checkoutsV2API = {
  /**
   * Body mínimo: { product_id, plan_id, name }
   * Opcionais (com defaults sensatos no backend):
   *   description, status (active/paused/archived),
   *   settings (JSONB livre), primary_color, layout_type,
   *   payment_methods { pix, boleto, credit_card } (booleans),
   *   pixel_id, require_gender, require_phone, require_address,
   *   chat_type, support_phone,
   *   coupon_enabled, popup_enabled, customization_enabled,
   *   steps_enabled, notifications_enabled, slug
   */
  create: (data) => v2Api.post('/checkouts', data),

  listByPlan: (planId) => v2Api.get(`/checkouts/by-plan/${planId}`),
  listByProduct: (productId) => v2Api.get(`/checkouts/by-product/${productId}`),

  findById: (id) => v2Api.get(`/checkouts/${id}`),
  findByUuid: (uuid) => v2Api.get(`/checkouts/uuid/${uuid}`),

  update: (id, data) => v2Api.patch(`/checkouts/${id}`, data),
  remove: (id) => v2Api.delete(`/checkouts/${id}`),
};

export default checkoutsV2API;
